// import { useRef } from 'react';
// import { motion } from 'framer-motion';
// import { shortcutKeys } from './GridAssetsData';
// import useClickOutside from '../UseClickOutside';

// export const GridOption = ({ setIsPopupOpen }) => {
//   const modalref = useRef(null);

//   useClickOutside(modalref, () => {
//     setIsPopupOpen(false);
//   });

//   const modalVariants = {
//     hidden: { opacity: 0, scale: 0.8, x: -50 }, // Start slightly left and scaled down
//     visible: { opacity: 1, scale: 1, x: 0, transition: { duration: 0.3 } }, // Animate to full size
//     exit: { opacity: 0, scale: 0.8, x: 50 }, // Exit to the right
//   };

//   return (
//     <div className="fixed top-0 h-screen w-screen z-[99999]">
//       <motion.div
//         ref={modalref}
//         variants={modalVariants}
//         initial="hidden"
//         animate="visible"
//         exit="exit"
//         style={{ boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.6)' }}
//         className="bg-[#131418] rounded-[5px] w-[200px]  z-[99999] h-fit absolute top-5 left-[235px] mx-2"
//       >
//         {shortcutKeys.map((item, index) =>
//           item.gap ? (
//             <div key={index} className="border-b border-[#2B2B2B] my-1"></div>
//           ) : (
//             <div
//               key={index}
//               className="flex justify-between items-center px-1 py-1 p hover:bg-[#37383F]  cursor-pointer"
//             >
//               <span className="text-[10px] text-nowrap text-[#D9D9D9] font-normal px-2">
//                 {item.key}
//               </span>
//               {item.label && (
//                 <span className="text-[10px] text-gray-400 px-2">
//                   {item.label}
//                 </span>
//               )}
//             </div>
//           )
//         )}
//       </motion.div>
//     </div>
//   );
// };




import { useRef } from 'react';
import { motion } from 'framer-motion';
import { shortcutKeys } from './GridAssetsData';
import useClickOutside from '../UseClickOutside';

export const GridOption = ({ setIsPopupOpen }) => {
  const modalref = useRef(null);

  useClickOutside(modalref, () => {
    setIsPopupOpen(false);
  });

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8, x: -50 },
    visible: { opacity: 1, scale: 1, x: 0, transition: { duration: 0.3 } },
    exit: { opacity: 0, scale: 0.8, x: 50 },
  };

  return (
    <div className="fixed top-0 h-screen w-screen z-[99999]">
      <motion.div
        ref={modalref}
        variants={modalVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        style={{ boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.6)' }}
        className="bg-[#131418] rounded-[5px] w-[200px] z-[99999] h-fit absolute top-5 left-[235px] mx-2 p-1"
      >
        {shortcutKeys.map((item, index) =>
          item.gap ? (
            <div
              key={index}
              className="border-b border-[#2B2B2B] my-1  "
            />
          ) : (
            <button
              key={index}
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                item.onClick?.();
                // Defer close so the click does not fall through to toolbar buttons underneath.
                setTimeout(() => setIsPopupOpen(false), 0);
              }}
              className="
                w-full flex justify-between items-center
                px-2 py-1 text-left
                hover:bg-[#37383F]
                focus:bg-[#37383F]
                outline-none
                cursor-pointer
              "
            >
              <span className="text-[10px] text-[#D9D9D9] font-normal">
                {item.key}
              </span>

              {item.label && (
                <span className="text-[10px] text-gray-400">
                  {item.label}
                </span>
              )}
            </button>
          )
        )}
      </motion.div>
    </div>
  );
};
